import moment from 'moment';
import { StyledTableCell } from './tableStyle';
import { IconButton, Tooltip, Typography } from '@material-ui/core';
import { useContext } from 'react';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { Tcard } from './mainTcard';
import TodayIcon from '@material-ui/icons/Today';
import { TCaredDashboardContext } from '../tCaredDashboard-Provider';

export default function SaturdayList(props) {
    const { index, dt, isDragDisabled, classes } = props;
    const { handleCalendarButtonClick, portalSetting, handleTcardOpen, legendItems, tCardList, shortListByTrailter } = useContext(TCaredDashboardContext);

    return (
        <div key={index} className="sat-list">
            {tCardList.closeDaysSat.map((satDt) => {
                // const motCards = tCardList.bookingConfirmed.filter(
                //     (m) => moment(m.motdate).format('YYYY-MM-DD') === moment(satDt.dt).format('YYYY-MM-DD') && m.mot && m.status !== 'COLLECTED'
                // );
                return (
                    moment(dt).add(1, 'day').format('YYYY-MM-DD') === moment(satDt.dt).format('YYYY-MM-DD') && (
                        <>
                            <Typography className="sat-list-label">
                                {tCardList.closeDays.length > 6 ? moment(satDt.dt).format('ddd') : moment(satDt.dt).format('dddd')}
                                &nbsp; {moment(satDt.dt).format('DD-MMM-YY')}
                            </Typography>
                            <div className="sat-list-label-Wrap">
                                <Typography className="sat-list-label-Wrap-label">Holidays</Typography>
                                <Tooltip title="User Holiday" aria-label="UserHoliday">
                                    <IconButton size="medium" className="sat-list-label-Wrap-btn" onClick={() => handleCalendarButtonClick(satDt.dt)}>
                                        <TodayIcon fontSize="small" className="sat-icon" />
                                    </IconButton>
                                </Tooltip>
                            </div>{' '}
                            <div className={`sat-list-label-list custom-scroll`}>
                                {tCardList.usersHoliday
                                    .filter((m) => moment(m.date).format('YYYY-MM-DD') === moment(satDt.dt).format('YYYY-MM-DD'))
                                    .map((k) => (
                                        <div
                                            style={{
                                                background: k.bg,
                                                color: k.color,
                                                borderBottom: `1px solid ${portalSetting.portalSettingsIsHolidayColor}`,
                                                padding: 1
                                            }}
                                        >
                                            <Typography
                                                style={{
                                                    color: portalSetting.portalSettingsIsHolidayColor
                                                }}
                                                className="sat-list-label-list-name"
                                            >
                                                {k.name}
                                            </Typography>
                                        </div>
                                    ))}
                            </div>
                            <div className="m-3"></div>
                            <div className="card-body-container-main-header">
                                <Typography className="sat-list-label-Wrap-label">Day Shift</Typography>
                            </div>
                            <Droppable droppableId={`${moment(satDt.dt).format('YYYY-MM-DD')}-ds`} direction="vertical" isDropDisabled={isDragDisabled}>
                                {(provided, snapshot) => {
                                    const dayCards = tCardList.bookingConfirmed.filter(
                                        (m) =>
                                            moment(m.bd).format('YYYY-MM-DD') === moment(satDt.dt).format('YYYY-MM-DD') &&
                                            !m.cd &&
                                            !m.ns &&
                                            m.status === 'BOOKING CONFIRMED'
                                    );

                                    let sortedList = shortListByTrailter(dayCards);

                                    return (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            className={`sat-list-label-list custom-scroll`}
                                            // style={{ minHeight: '400px', overflowY: 'auto', position: 'relative' }}
                                        >
                                            {sortedList.length === 0 ? (
                                                <div className="card-body-container-main-wrapper-no-record">
                                                    <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                                </div>
                                            ) : (
                                                sortedList.map((k, idx) => (
                                                    <Draggable key={k.tCardsID} isDragDisabled={isDragDisabled} draggableId={k.tCardsID.toString()} index={idx}>
                                                        {(provided) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    ...provided.draggableProps.style
                                                                }}
                                                            >
                                                                <Tcard
                                                                    legendItems={legendItems}
                                                                    days={k.days}
                                                                    handleTcardOpen={handleTcardOpen}
                                                                    date={k.bd}
                                                                    customer={k.cust}
                                                                    isLoanVehicle={k.loanVehicle}
                                                                    registration={k.reg}
                                                                    textColor={k.tc}
                                                                    color={k.bgc}
                                                                    tCardsID={k.tCardsID}
                                                                    wn={k.wn}
                                                                    vsc={k.vsc}
                                                                    breakdown={k.breakdown}
                                                                    breakdownStatus={k.breakdownStatus}
                                                                    breakdownTime={k.breakdownTime}
                                                                    status={{
                                                                        recall: k.recall,
                                                                        tacho: k.tacho,
                                                                        mot: k.mot,
                                                                        repair: k.repair,
                                                                        inspection: k.inspection,
                                                                        cd: k.cd,
                                                                        waiting: k.waiting,
                                                                        service: k.service,
                                                                        ns: k.ns
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))
                                            )}
                                            {snapshot.isDraggingOver && sortedList.length > 0 && (
                                                <div className={classes.noRecordFound}>
                                                    <span>Drop Here</span>
                                                </div>
                                            )}
                                            {provided.placeholder}
                                        </div>
                                    );
                                }}
                            </Droppable>
                            <div className="m-3"></div>
                            <div className="card-body-container-header">
                                <Typography className="sat-list-label-Wrap-label">Collection and Delivery</Typography>
                            </div>
                            <Droppable droppableId={`${moment(satDt).format('YYYY-MM-DD')}-cd`} direction="vertical" isDropDisabled={isDragDisabled}>
                                {(provided, snapshot) => {
                                    const cdCards = tCardList.bookingConfirmed.filter(
                                        (m) =>
                                            moment(m.bd).format('YYYY-MM-DD') === moment(satDt.dt).format('YYYY-MM-DD') &&
                                            m.cd &&
                                            !m.ns &&
                                            m.status === 'BOOKING CONFIRMED'
                                    );

                                    let sortedList = shortListByTrailter(cdCards);

                                    return (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            className={`sat-list-label-list custom-scroll`}
                                            // style={{ minHeight: '400px', overflowY: 'auto', position: 'relative' }}
                                        >
                                            {sortedList.length === 0 ? (
                                                <div className={'card-body-container-main-wrapper-no-record'}>
                                                    <span>{snapshot.isDraggingOver ? 'Drop Here' : 'No Record Found'}</span>
                                                </div>
                                            ) : (
                                                sortedList.map((k, idx) => (
                                                    <Draggable key={k.tCardsID} isDragDisabled={isDragDisabled} draggableId={k.tCardsID.toString()} index={idx}>
                                                        {(provided) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    ...provided.draggableProps.style
                                                                }}
                                                            >
                                                                <Tcard
                                                                    legendItems={legendItems}
                                                                    handleTcardOpen={handleTcardOpen}
                                                                    days={k.days}
                                                                    date={k.bd}
                                                                    customer={k.cust}
                                                                    isLoanVehicle={k.loanVehicle}
                                                                    registration={k.reg}
                                                                    textColor={k.tc}
                                                                    color={k.bgc}
                                                                    tCardsID={k.tCardsID}
                                                                    breakdown={k.breakdown}
                                                                    wn={k.wn}
                                                                    vsc={k.vsc}
                                                                    breakdownStatus={k.breakdownStatus}
                                                                    breakdownTime={k.breakdownTime}
                                                                    status={{
                                                                        recall: k.recall,
                                                                        tacho: k.tacho,
                                                                        mot: k.mot,
                                                                        repair: k.repair,
                                                                        inspection: k.inspection,
                                                                        cd: k.cd,
                                                                        waiting: k.waiting,
                                                                        service: k.service,
                                                                        ns: k.ns
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))
                                            )}
                                            {snapshot.isDraggingOver && sortedList.length > 0 && (
                                                <div className={classes.noRecordFound}>
                                                    <span>Drop Here</span>
                                                </div>
                                            )}
                                            {provided.placeholder}
                                        </div>
                                    );
                                }}
                            </Droppable>
                            <div className="m-3"></div>
                        </>
                    )
                );
            })}
        </div>
    );
}
